import { groupBy } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();

export default class SalidasInventario {
  constructor() {}

  static getDocData(mainData) {
    let tableBody = this.getGroupedTable(mainData.data);

    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",
      pageSize: {
        width: 500,
        height: "auto",
      },
      content: [
        {
          columns: [
            {
              width: "100%",
              alignment: "center",
              bold: true,
              fontSize: 15,
              text: [mainData.TITLE + "\n"],
            },
          ],
        },
        {
          columns: [
            {
              width: "100%",
              alignment: "left",
              bold: true,
              fontSize: 15,
              text: ["Departamento: " + mainData.dep + "\n"],
            },
          ],
        },
        {
          columns: [
            {
              width: "100%",
              bold: true,
              fontSize: 15,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora Generado: " + mainData.HG + "\n",
              ],
            },
          ],
        },
        {
          columns: [
            {
              width: "100%",
              table: {
                widths: ["40%", "40%", "20%"],
                body: tableBody,
              },
            },
          ],
          margin: [0, 10, 0, 0],
        },
      ],
    };

    return docDefinition;
  }

  static getGroupedTable(data) {
    const headers = [
      {
        text: "Producto",
        border: [true, true, true, true],
        fontSize: 20,
        alignment: "center",
        fillColor: "#eeeeee",
        bold: true,
      },
      {
        text: "Motivo",
        border: [true, true, true, true],
        fontSize: 20,
        alignment: "center",
        fillColor: "#eeeeee",
        bold: true,
      },
      {
        text: "Cantidad",
        border: [true, true, true, true],
        fontSize: 20,
        alignment: "center",
        fillColor: "#eeeeee",
        bold: true,
      },
    ];

    const items = [headers];

    const grouped = groupBy(data, "id");

    Object.values(grouped).forEach((grupo) => {
      const base = grupo[0];
      const UM = base.Unidad
      let cantidadTotalSalida = 0;

      // nombre del producto
      items.push([
        {
          text: base.Nombre,
          border: [true, false, true, false],
          fontSize: 20,
          alignment: "left",
          bold: true,
          colSpan: 3,
        },
        {},
        {},
      ]);

      // motivos del producto
      grupo.forEach((producto) => {
        cantidadTotalSalida += producto.Cantidad;

        items.push([
          {
            text: "",
            border: [true, false, true, false],
            fontSize: 20,
          },
          {
            text: producto.MotivoNombre,
            border: [true, false, true, false],
            fontSize: 20,
            alignment: "left",
          },
          {
            text: producto.Cantidad + " " + UM,
            border: [true, false, true, false],
            fontSize: 20,
            alignment: "center",
          },
        ]);
      });

      // total
      items.push([
        {
          text: "TOTAL SALIDA",
          border: [true, false, false, true],
          fontSize: 20,
          alignment: "right",
          bold: true,
          colSpan: 2,
        },
        {},
        {
          text: cantidadTotalSalida + " " + UM,
          border: [false, true, true, true],
          fontSize: 20,
          alignment: "center",
          bold: true,
        },
      ]);
    });

    return items;
  }
}
